import Settings from '../../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 50,
    TINT: 0x000000,
    TEXT: '15 000',
};

export default class Total extends Phaser.GameObjects.Container {
    private config: any;
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, config: any) {
        super(scene, x, y);

        this.config = config;

        this.setupIcon();
        this.setupLabel();
    }

    setupIcon() {
        let x = 0;
        let y = 5;
        let frame = 'gui/hard_currency/icon';

        this.icon = this.scene.add.image(x, y, 'atlas', frame);
        this.icon.setOrigin(0);
        this.add(this.icon);
    }

    setupLabel() {
        let x = 55;
        let y = 0;

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, LABEL.TEXT, LABEL.SIZE);
        this.label.setTint(LABEL.TINT);
        this.add(this.label);
    }
}
